import { useEffect } from "react";
import { X, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { PageHero, FinalCta } from "../components/Sections";
import { DONT_DO, WE_DO, DIAGNOSTIC_QUESTIONS, PROCESS } from "../data/site";

const WhyAlbl = () => {
    useEffect(() => {
        document.title = "Why ALBL | Not Another Digital Marketing Agency — Narmadapuram & Itarsi";
    }, []);

    return (
        <main>
            <PageHero
                eyebrow="Why ALBL"
                title="YOU DON'T NEED ANOTHER MARKETING AGENCY."
                sub="Most agencies sell you posts, reels, websites and 'digital marketing'. ALBL starts somewhere else — with the business."
            />

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <Eyebrow>We answer these first</Eyebrow>
                            <div className="gold-rule mt-6" />
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <Reveal delay={100}>
                            <div className="grid sm:grid-cols-2 gap-3">
                                {DIAGNOSTIC_QUESTIONS.map((q, i) => (
                                    <div key={q} className="border border-slate-200 bg-[#F8FAFC] px-5 py-5">
                                        <span className="font-serif-accent italic text-[#C5A059] text-lg">
                                            0{i + 1}
                                        </span>
                                        <p className="mt-1 text-sm sm:text-base text-slate-800 font-medium">{q}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-8 text-slate-600 text-base sm:text-lg leading-relaxed">
                                We answer those questions first.{" "}
                                <span className="text-slate-900 font-semibold">
                                    Then we build the marketing around the business.
                                </span>
                            </p>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="bg-[#0D131F] text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-2 gap-14">
                    <Reveal>
                        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.1]">
                            WHAT WE DON&apos;T DO.
                        </h2>
                        <ul className="mt-10 space-y-5">
                            {DONT_DO.map((item) => (
                                <li key={item} className="flex gap-4 items-start">
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center border border-red-400/50">
                                        <X className="h-3 w-3 text-red-400" />
                                    </span>
                                    <span className="text-slate-300 text-sm sm:text-base uppercase tracking-wide">
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                    <Reveal delay={150}>
                        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.1] text-[#C5A059]">
                            WHAT WE DO.
                        </h2>
                        <ul className="mt-10 space-y-5">
                            {WE_DO.map((item) => (
                                <li key={item} className="flex gap-4 items-start">
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center border border-[#C5A059]/60">
                                        <Check className="h-3 w-3 text-[#C5A059]" />
                                    </span>
                                    <span className="text-slate-200 text-sm sm:text-base">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </section>

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow>How we work</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.1] mt-5">
                            NO COOKIE-CUTTER MARKETING.
                        </h2>
                    </Reveal>
                    <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
                        {PROCESS.map((p) => (
                            <div key={p.num} className="bg-white p-8">
                                <span className="font-serif-accent italic text-3xl text-[#C5A059]">{p.num}</span>
                                <h3 className="font-display text-xl font-bold text-slate-900 uppercase tracking-tight mt-4">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <FinalCta />
        </main>
    );
};

export default WhyAlbl;
